import { getAxios } from './service.helpers';

export default class OrganizationService {
  static create = async (affiliateData) => {
    const axios = await getAxios();

    const { status, statusText, data } = await axios.post('/organization', affiliateData);

    if (status < 200 || status > 299) {
      throw new Error(statusText);
    }

    const { success, data: affiliate, error } = data;

    if (!success) {
      throw error;
    }

    return affiliate;
  };

  static read = async () => {
    const axios = await getAxios();

    const { status, statusText, data } = await axios.get('/organization');

    if (status < 200 || status > 299) {
      throw new Error(statusText);
    }

    const { success, data: organizations, error } = data;

    if (!success) {
      throw error;
    }

    return organizations;
  };

  static update = async (affiliateId, updates) => {
    const axios = await getAxios();

    const { status, statusText, data } = await axios.patch(`/organization/${affiliateId}`, updates);

    if (status < 200 || status > 299) {
      throw new Error(statusText);
    }

    const { success, data: affiliate, error } = data;

    if (!success) {
      throw error;
    }

    return affiliate;
  };

  static delete = async (affiliateId) => {
    const axios = await getAxios();

    const { status, statusText, data } = await axios.delete(`/organization/${affiliateId}`);

    if (status < 200 || status > 299) {
      throw new Error(statusText);
    }

    const { success, error } = data;

    if (!success) {
      throw error;
    }
  };
}
